var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.5213 15.5254 19.9975 10.0046 20H9.89667C9.41192 19.995 8.92817 19.955 8.44917 19.8804C8.05693 19.8198 7.66872 19.7355 7.28667 19.6279C5.18907 19.036 3.34217 17.7752 2.02688 16.0373C0.711591 14.2994 -0.00011743 12.1795 1.45329e-08 10C1.45329e-08 4.47792 4.47583 3.98945e-06 10 3.98945e-06H10.0046C11.365 -0.00121305 12.7113 0.276038 13.9606 0.814688C15.2099 1.35334 16.3357 2.14199 17.2688 3.13209C19.0236 4.98811 20.0009 7.44574 20 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47458 7.02531V7.47531H6.02083L1.9375 4.0799C2.1899 3.73656 2.46407 3.40978 2.75833 3.10156L7.47458 7.02531Z",
    fill: "#C8102E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0734 4.10068L14.0139 7.47568H12.5234V7.05818L17.2559 3.12109L17.2684 3.13401C17.5412 3.42157 17.7964 3.72532 18.0326 4.04359L18.0734 4.10068Z",
    fill: "#C8102E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47417 12.5234V12.9734L2.75792 16.898C2.71625 16.8564 2.67458 16.8114 2.63542 16.7676C2.38733 16.498 2.15433 16.215 1.9375 15.9197L6.02083 12.5234H7.47417Z",
    fill: "#C8102E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0739 15.9009C17.8225 16.2445 17.5494 16.5717 17.2564 16.8805L12.5234 12.943V12.5234H14.0139L18.0739 15.9009Z",
    fill: "#C8102E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99281 7.47427H0.320312C0.528949 6.67416 0.836897 5.90331 1.23698 5.17969L3.99281 7.47427Z",
    fill: "#012169"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9099 12.5234L1.2074 14.7709C0.821197 14.0607 0.523292 13.306 0.320312 12.5234H3.9099Z",
    fill: "#012169"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47198 14.6367V19.6784C7.40865 19.6621 7.34698 19.6451 7.2824 19.6271C5.97208 19.2581 4.75127 18.6246 3.69531 17.7655L7.47198 14.6367Z",
    fill: "#012169"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47823 0.320312V5.28281L3.75781 2.18781C4.85265 1.31034 6.12045 0.673952 7.47823 0.320312Z",
    fill: "#012169"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3009 2.23406L12.5234 5.36531V0.320312L12.5805 0.334896C13.941 0.697813 15.209 1.34511 16.3009 2.23406Z",
    fill: "#012169"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6771 7.4738H16.0938L18.79 5.23047C19.1758 5.93939 19.4737 6.69273 19.6771 7.4738Z",
    fill: "#012169"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3309 17.7417C15.2167 18.6553 13.9177 19.3164 12.5234 19.6796V14.5742L16.3309 17.7417Z",
    fill: "#012169"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6797 12.5234C19.4811 13.2871 19.1922 14.0243 18.8193 14.7197L16.1797 12.5234H19.6797Z",
    fill: "#012169"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.89542V10.095C19.9957 10.5613 19.9591 11.0267 19.8904 11.4879H11.4879V19.89C11.0296 19.9584 10.5671 19.9951 10.1038 20H9.89542C9.43189 19.9952 8.96926 19.9583 8.51083 19.8896V11.4879H0.11C0.041626 11.029 0.00487275 10.566 0 10.1021C0 10.0367 0 9.97083 0 9.905C0.00431054 9.43858 0.040926 8.97302 0.109583 8.51167H8.51208V0.11C8.9484 0.0447683 9.38849 0.00802389 9.82958 0L10.1521 0C10.573 0.00601834 10.9932 0.038583 11.41 0.0975L11.4879 0.109167V8.51167H19.89C19.9584 8.96985 19.9951 9.43219 20 9.89542Z",
    fill: "#C8102E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.7502b07bd2574e08d202c102d58e3643.svg";
export { ForwardRef as ReactComponent };